// ---------------------------------------------------------------
// PauseScreen.js — Pantalla de desconexión en los días libres.
// Si el empleado entra a la web un día sin turno (descanso,
// vacaciones o descanso post-guardia), se le invita a desconectar:
// se ocultan tareas y mensajes y se le dice cuándo es su próximo
// día de trabajo. Un botón le permite continuar igualmente (y no
// se le vuelve a preguntar en todo el día).
// ---------------------------------------------------------------
import { cerrarSesion } from "../services/authService";
import { useEffect, useState } from "react";
import { getScheduleOnce, monthKey } from "../services/scheduleService";
import { fromISO, longDate } from "../utils/date";

/** ¿Es un día libre? (sin turnos y sin estar de baja) */
export function isFreeDay(info) {
  return !!info && !info.baja && !(info.shifts?.length);
}

/** Busca el próximo día CON turno del usuario (este mes y, si hace
 *  falta, el siguiente). Devuelve { date: Date, start: "HH:MM" }. */
async function findNextWorkday(uid, schedule) {
  const now = new Date();
  const scan = (days, year, month, fromDay) => {
    const total = new Date(year, month, 0).getDate();
    for (let d = fromDay; d <= total; d++) {
      const info = days?.[String(d)];
      if (info?.shifts?.length && !info.baja) {
        const start = info.shifts
          .map((s) => s.start)
          .sort()[0];
        return { date: fromISO(`${year}-${String(month).padStart(2, "0")}-${String(d).padStart(2, "0")}`), start };
      }
    }
    return null;
  };

  const y = now.getFullYear();
  const m = now.getMonth() + 1;
  const found = scan(schedule?.days, y, m, now.getDate() + 1);
  if (found) return found;

  const nextY = m === 12 ? y + 1 : y;
  const nextM = (m % 12) + 1;
  const nextSchedule = await getScheduleOnce(uid, monthKey(nextY, nextM));
  return scan(nextSchedule?.days, nextY, nextM, 1);
}

export default function PauseScreen({ uid, displayName, schedule, onContinue }) {
  const [next, setNext] = useState(undefined); // undefined = cargando

  useEffect(() => {
    let alive = true;
    findNextWorkday(uid, schedule)
      .then((res) => alive && setNext(res))
      .catch(() => alive && setNext(null));
    return () => {
      alive = false;
    };
  }, [uid, schedule]);

  return (
    <div className="pause-screen">
      <div className="pause-card">
 <span className="pause-emoji"></span>
        <h1 className="pause-title">Estás fuera de tu jornada</h1>
        <p className="pause-text">
          {displayName ? `${displayName}, hoy` : "Hoy"} no te toca trabajar.
          Disfruta de tu tiempo libre: tus tareas y los mensajes de la
 farmacia quedan en pausa hasta tu vuelta. 
        </p>
        <p className="pause-next">
          {next === undefined && "Buscando tu próximo día de trabajo…"}
          {next === null && "Aún no hay un próximo turno publicado en tu horario."}
          {next && (
            <>
              Nos vemos el <strong>{longDate(next.date)}</strong>
 {next.start && <> a las <strong>{next.start}</strong></>}. 
            </>
          )}
        </p>

        <div className="pause-actions">
          <span className="pause-question">¿Necesitas entrar igualmente?</span>
          <button className="btn-primary" onClick={onContinue}>
            Sí, continuar
          </button>
          <button className="pause-signout" onClick={cerrarSesion}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
